export default __webpack_public_path__ + "static/media/volvo def fase 2-70.681f7ccb.jpg";